import { render, staticRenderFns } from "./ketogenesis.vue?vue&type=template&id=ec2875dc&scoped=true&"
import script from "./ketogenesis.vue?vue&type=script&lang=js&"
export * from "./ketogenesis.vue?vue&type=script&lang=js&"
import style0 from "./ketogenesis.vue?vue&type=style&index=0&id=ec2875dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2875dc",
  null
  
)

export default component.exports